import React,{useState, useEffect, useMemo} from 'react'
import _ from "lodash"
import PaginatedItems from "./PaginatedItems";
import { getAllStaffs } from "../../../services/employStaff";

function SelectInput(props) {
    const [selectedDepts,setSelectedDepts] = useState("")
    const [staff,setStaff] = useState()

    // Sort departments to put "Rectorate Department" first
    const sortedDepts = useMemo(() => {
      if (!props.depts) return [];
      return [...props.depts].sort((a, b) => {
        if (a.department === "Rectorate Department") return -1;
        if (b.department === "Rectorate Department") return 1;
        return 0;
      });
    }, [props.depts]);

    // Set default to "Rectorate Department" if it exists, otherwise first department
    useEffect(() => {
      if (sortedDepts && sortedDepts.length > 0 && !selectedDepts) {
        const rectorateDept = sortedDepts.find(d => d.department === "Rectorate Department");
        setSelectedDepts(rectorateDept ? rectorateDept.department : sortedDepts[0].department);
      }
    }, [sortedDepts, selectedDepts]);

    let filteredStaff;
    if(selectedDepts && staff){
      filteredStaff =  _.filter(staff, ['department', (selectedDepts)])
    }
    else{
      filteredStaff = []
    }
 
    const handleChange = (e) => {
      setSelectedDepts(e.currentTarget.value)
    }   

    useEffect(() => {
      async function fetchData() {
        const response = await getAllStaffs();
        setStaff(response.data);
      }
      fetchData();
    }, []);


  return (
    <>
    
    <div className='flex flex-row justify-center items-center py-5'>
        <label htmlFor="Filter" className='text-[15px] font-base bg-slate-300 py-2 px-3 rounded-lg rounded-r-none'>Filter</label> 
    <select name="filter" id="filter" value={selectedDepts} onChange={(e) => handleChange(e)} className="py-2 px-4 pe-16  md:w-[50%] xl:w-[40%]  rounded-lg rounded-l-none text-sm xs:text-[12px] focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600">
   {sortedDepts && sortedDepts.map( p =>(
           <option key={p.code} value={p.department} >{p.department}</option>
   )
   )
   }
  </select>
  </div>
  <PaginatedItems list={filteredStaff} itemsPerPage="6" />
  
  </>
  )
}

export default SelectInput